mutation MapRevitValue(
    $parameterID: ID!
    $bimClassID: ID
    $value: Value!
    $revitValue: Value!
) {
    mapRevitValue(
        parameterID: $parameterID
        bimClassID: $bimClassID
        value: $value
        revitValue: $revitValue
    ) {
        id
        parameterID
        bimClassID
        value
        revitValue
    }
}
